module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salary-rules__rule-container"
  }, [_c('div', {
    staticClass: "d-input-group--toggler",
    class: {
      'd-input-group--toggler--active': _vm.isOn
    },
    on: {
      "click": _vm.setIsOn
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n      Skal mellemtimer automatisk give tid\n    ")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isOn
    }
  })], 1), _vm._v(" "), (_vm.isOn) ? _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Hvor mange minutter skal mellemtimen max være?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minutes),
      expression: "minutes"
    }],
    ref: "input_number",
    staticClass: "d-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.minutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minutes = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isOn) ? _c('SalaryRulesRule', {
    attrs: {
      "subjectType": _vm.subjectType,
      "propSelectedEmploymentTypeId": _vm.selectedEmploymentTypeId
    },
    on: {
      "change": _vm.setRuleEmployment
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isChangesMade) ? _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0452f0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettingsRules/SalaryRule2.vue
// module id = 2115
// module chunks = 1